import React from 'react';

import { Typography } from '@mui/material';

import {
  formatAuditTimestamp,
  getDisplayValue,
  humanizeAuditAction,
} from '../../SnapdocsClosingSection.utils';

import { wrappingCellStyles } from './SnapdocsAuditTrailBlock.styles';

export const auditTrailTableConfig = {
  createdAt: {
    label: 'Date',
    width: '22%',
    content: event => (
      <Typography color="text.secondary" variant="regular14">
        {formatAuditTimestamp(event.createdAt)}
      </Typography>
    ),
  },
  action: {
    label: 'Action',
    width: '28%',
    content: event => (
      <Typography sx={wrappingCellStyles} variant="medium14">
        {humanizeAuditAction(event.action)}
      </Typography>
    ),
  },
  userName: {
    label: 'User',
    width: '18%',
    content: event => (
      <Typography color="text.secondary" variant="regular14">
        {getDisplayValue(event.userName)}
      </Typography>
    ),
  },
  notes: {
    label: 'Notes',
    width: '32%',
    content: event => (
      <Typography color="text.secondary" sx={wrappingCellStyles} variant="regular14">
        {getDisplayValue(event.notes)}
      </Typography>
    ),
  },
};
